import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

export const getGroupModeratorsList = createAsyncThunk(
    "getGroupModeratorsList",
    async (GroupId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/group/groups/${GroupId}/admins/`);
            return response.data;
        } catch (error) {
            // Fix #8 + #10: use rejectWithValue so rejected case fires correctly
            console.error("Error:", error?.response?.data);
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const promoteGroupModerator = createAsyncThunk(
    "promoteGroupModerator",
    async ({ groupId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/group/groups/${groupId}/promote-demote/`, data);
            return response.data;
        } catch (error) {
            console.error("Error:", error?.response?.data);
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const dePromoteGroupModerator = createAsyncThunk(
    "dePromoteGroupModerator",
    async ({ groupId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(`/group/groups/${groupId}/promote-demote/`, { data });
            return response.data;
        } catch (error) {
            console.error("Error:", error?.response?.data);
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const GroupModeratorsSlice = createSlice({
    name: "GroupModeratorsSlice",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder.addCase(getGroupModeratorsList.pending, (state) => {
            state.loading = true;
            // Fix #9: don't set error=true while loading — clear it instead
            state.error = null;
        });
        builder.addCase(getGroupModeratorsList.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(getGroupModeratorsList.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    },
});

export default GroupModeratorsSlice.reducer;
